import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ChevronDownSvg from 'images/v5/icons/chevron-down.svg';
import FilterSvg from 'images/v5/icons/filter-lines.svg';
import LoopSvg from 'images/v5/icons/search-md.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Input from 'layout/atoms/Input/Input';
import Loader from 'layout/atoms/Loader/Loader';
import ComponentAccordionCard from 'layout/molecules/ComponentAccordionCard';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import FiltersBar from 'layout/molecules/FiltersBar/FiltersBar';
import Grid from 'layout/molecules/Grid/Grid';
import parseComponentsByCategory from 'parsers/specification/parseComponentsByCategory';
import { fetchPreviewConsumptions, fetchPreviewQuantities, selectSpecificationPreviewStatus, } from 'store/specificationPreviewSlice';
import { fetchSuppliers, selectSuppliers } from 'store/suppliersSlice';
import getCategoryLabel from 'utils/getCategoryLabel';
function Consumptions() {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation(['specification', 'common']);
    const specificationDetails = useSelector((state) => state.specificationPreview.item);
    const status = useSelector(selectSpecificationPreviewStatus);
    const [searchQuery, setSearchQuery] = useState('');
    const [supplierFilter, setSupplierFilter] = useState(null);
    const suppliersData = useSelector(selectSuppliers);
    useEffect(() => {
        if (status.fetchConsumptions === 'idle' && (specificationDetails === null || specificationDetails === void 0 ? void 0 : specificationDetails.id)) {
            dispatch(fetchPreviewConsumptions({ specificationId: specificationDetails.id }));
        }
    }, [dispatch, status.fetchConsumptions, specificationDetails === null || specificationDetails === void 0 ? void 0 : specificationDetails.id]);
    useEffect(() => {
        if (status.fetchQuantities === 'idle' && (specificationDetails === null || specificationDetails === void 0 ? void 0 : specificationDetails.id)) {
            dispatch(fetchPreviewQuantities({ specificationId: specificationDetails.id }));
        }
    }, [dispatch, status.fetchQuantities, specificationDetails === null || specificationDetails === void 0 ? void 0 : specificationDetails.id]);
    useEffect(() => {
        dispatch(fetchSuppliers());
    }, [dispatch]);
    if (status.fetchConsumptions === 'idle' ||
        status.fetchConsumptions === 'loading' ||
        status.fetchQuantities === 'idle' ||
        status.fetchQuantities === 'loading') {
        return React.createElement(Loader, null);
    }
    const components = specificationDetails.components.edges.map((item) => {
        var _a;
        const component = item.node;
        const productSnapshot = component === null || component === void 0 ? void 0 : component.productSnapshot;
        const product = productSnapshot === null || productSnapshot === void 0 ? void 0 : productSnapshot.product;
        const variants = productSnapshot === null || productSnapshot === void 0 ? void 0 : productSnapshot.variantSnapshots.edges.map((item) => item.node);
        return Object.assign(Object.assign(Object.assign({}, component), product), { id: component.id, name: component.name, producerCode: product === null || product === void 0 ? void 0 : product.producerCode, supplier: {
                fullName: productSnapshot === null || productSnapshot === void 0 ? void 0 : productSnapshot.supplierFullName,
                shortName: productSnapshot === null || productSnapshot === void 0 ? void 0 : productSnapshot.supplierFullName,
            }, variants, activeProductVariantsCount: variants.length, productVariantsCount: variants.length, status: (_a = component === null || component === void 0 ? void 0 : component.productSnapshot) === null || _a === void 0 ? void 0 : _a.product.status });
    });
    const filteredComponents = components.filter((component) => {
        var _a, _b;
        const matchesSearch = (_a = component.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchQuery);
        const matchesSupplier = supplierFilter
            ? ((_b = component.supplier) === null || _b === void 0 ? void 0 : _b.shortName) === supplierFilter
            : true;
        return matchesSearch && matchesSupplier;
    });
    const categorizedComponents = parseComponentsByCategory(filteredComponents);
    const handleSearchFilter = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };
    const handleSupplierFilter = (shortName) => {
        if (shortName !== supplierFilter) {
            setSupplierFilter(shortName);
        }
        else {
            setSupplierFilter(null);
        }
    };
    return (React.createElement(Grid, { columns: 1, gap: 24 },
        React.createElement(FiltersBar, { noPadding: true, searchInput: React.createElement(Input, { size: "s", leftIcon: React.createElement(LoopSvg, null), placeholder: t('common:search'), onChange: (e) => handleSearchFilter(e) }) },
            React.createElement(Dropdown, { trigger: React.createElement(Button, { theme: "border", leftIcon: React.createElement(FilterSvg, null), rightIcon: React.createElement(ChevronDownSvg, null) }, supplierFilter || t('suppliers_base')) }, suppliersData.status === 'succeeded' ? (suppliersData.items.map((supplier) => (React.createElement(Button, { key: supplier.shortName, align: "left", theme: supplierFilter === supplier.shortName ? 'fill' : 'ghost', onClick: () => handleSupplierFilter(supplier.shortName) }, supplier.shortName)))) : (React.createElement(Loader, { size: "m" })))),
        categorizedComponents.length === 0 && (React.createElement(EmptyState, { size: "s", header: t('common:no_results_header'), subheader: t('common:no_results_subheader') })),
        categorizedComponents.map((category) => (React.createElement(Grid, { key: category.categoryId, columns: 1, gap: 12 },
            React.createElement("h3", null, getCategoryLabel(category, i18n)),
            React.createElement(Grid, { columns: 1 }, category.items.map((component) => (React.createElement(ComponentAccordionCard, { key: component.id, component: component, specificationId: specificationDetails === null || specificationDetails === void 0 ? void 0 : specificationDetails.id })))))))));
}
export default Consumptions;
